import { UserSettingsNotice } from 'feature/user/view'
import { MainLayout } from 'layouts'

export function UserSettingsNoticePage() {
  return (
    <MainLayout>
      <div className='container'>
        <UserSettingsNotice />
      </div>
    </MainLayout>
  )
}
